import React from 'react';

const ChevronRightIcon = () => {
  return (
    <svg
      width='6'
      height='10'
      viewBox='0 0 6 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.195913 1.13807C-0.064437 0.877721 -0.064437 0.455612 0.195913 0.195262C0.456262 -0.0650874 0.878372 -0.0650874 1.13872 0.195262L5.13872 4.19526C5.39111 4.44765 5.39994 4.85404 5.15875 5.11715L1.49209 9.11715C1.24329 9.38856 0.82158 9.4069 0.550167 9.1581C0.278754 8.90931 0.260419 8.4876 0.509214 8.21618L3.74456 4.68672L0.195913 1.13807Z'
        fill='#5D665F'
      />
    </svg>
  );
};

export default ChevronRightIcon;
